<template>
  <div id="LinkPayPage" class="link-pay-page">
    <div class="link-pay-shell">
      <loading v-if="loadingRender"></loading>
      <panel
        Title="سامانه لینک پرداخت"
        :Des="pageDescription"
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
        @back="goToLogin"
      ></panel>
      <net-pa-card class="link-pay-card">
        <template slot="header">
          <div class="link-pay-card-head">
            <h6 class="text-right mb-0">
              <i class="fas fa-link ml-2"></i>
              {{ QrCode ? 'QR Code پرداخت' : 'واریز از طریق لینک' }}
            </h6>
            <button type="button" class="link-pay-qr-toggle" @click="QrCode = !QrCode">
              <i class="fas fa-qrcode ml-1" aria-hidden="true"></i>
              {{ QrCode ? 'بازگشت به فرم' : 'QR Code' }}
            </button>
          </div>
        </template>
        <template slot="content">
          <form v-show="!QrCode" id="div1" class="link-pay-form" dir="rtl" @submit.prevent>
            <div class="link-pay-layout">
              <div class="link-pay-main">
                <div v-if="!IsQuery" class="link-pay-lookup">
                  <input
                    autocomplete="off"
                    class="form-control link-pay-input text-center"
                    id="Shenase"
                    type="number"
                    placeholder="شناسه واریز"
                    v-model="Shenase"
                    v-mask="'####################'"
                  />
                  <button type="button" class="link-pay-check" @click="CheckupShenase()" dir="ltr">
                    بررسی
                  </button>
                </div>

                <div v-if="Result != null" class="link-pay-result">
                  <span>{{ Result.nameFamily }}</span>
                  <span>{{ Result.desNoe }}</span>
                  <span v-if="Result.tblSarfaslTypeId == 1" class="link-pay-result__due">
                    سررسید {{ Result.minTarGhestBedehkar }}
                  </span>
                </div>

                <input
                  class="form-control link-pay-input link-pay-amount text-center"
                  id="Mab"
                  :disabled="FixVariz"
                  v-model="Mablagh"
                  dir="ltr"
                  type="number"
                  placeholder="مبلغ واریزی (ریال)"
                />
                <div class="link-pay-amount-meta">
                  <span class="link-pay-amount-formatted">{{ $Comma3ragham(Mablagh) }}</span>
                  <span class="link-pay-amount-words">{{ ToPersian(Mablagh) }} ریال</span>
                </div>

                <div class="link-pay-payer">
                  <input
                    class="form-control link-pay-input text-center required"
                    type="text"
                    placeholder="نام و نام خانوادگی"
                    :value="NameFamily"
                    @input="onNameFamilyInput"
                    :disabled="IsLinkPayCustom"
                  />
                  <input
                    class="form-control link-pay-input text-center required"
                    dir="ltr"
                    type="number"
                    @keypress="$ValidNumber($event, 11)"
                    placeholder="شماره تلفن"
                    v-model="Mobile"
                    :disabled="IsLinkPayCustom"
                  />
                </div>
                <textarea
                  class="form-control link-pay-input link-pay-notes text-center"
                  placeholder="توضیحات"
                  maxlength="300"
                  rows="2"
                  v-model="Description"
                  :disabled="IsLinkPayCustom"
                ></textarea>

                <div class="link-pay-captcha">
                  <CaptchaBox
                    ref="captchaRef"
                    :width="130"
                    :height="40"
                    @update="onCaptchaValid"
                  ></CaptchaBox>
                </div>
              </div>

              <aside class="link-pay-checkout">
                <payment
                  v-if="wwwtblShobeid != null"
                  @GatewayCode="Get_GatewayCode"
                  @FixVarizGhestHasJarime="FixVarizGhestHasJarime"
                  @FixVarizGhest="FixVarizGhest"
                  :wwwtblShobeid="wwwtblShobeid"
                >
                  <template v-slot:ContentButtonPayment>
                    <button
                      id="BtnPayment"
                      type="button"
                      class="btn link-pay-submit"
                      :class="Result == null || Number(Mablagh) < 10000 ? 'btn-secondary' : 'btn-success'"
                      :disabled="Result == null || Number(Mablagh) < 10000"
                      @click.prevent="Payment"
                    >
                      واریز {{ $Comma3ragham(Mablagh) }} ریال
                    </button>
                    <div id="AletSumMab" class="alert alert-info w-100 font-weight-bold d-none">
                      تسهیلات انتخابی شما تسویه شده است. برای اطمینان بیشتر با
                      {{ $session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' }}
                      / شعبه تماس بگیرید.
                    </div>
                  </template>
                </payment>
                <p v-else class="link-pay-hint">
                  شناسه واریز را بررسی کنید تا درگاه پرداخت نمایش داده شود.
                </p>
              </aside>
            </div>
          </form>

          <div v-show="QrCode" class="link-pay-qr" dir="rtl">
            <div id="qrcode" class="link-pay-qr-box">
              <h4 class="link-pay-qr-name">{{ Result != null ? Result.nameFamily : '' }}</h4>
              <qrcode-vue :value="value" :size="size" :render-as="'svg'" level="H" />
              <a class="link-pay-qr-link" :href="value" dir="ltr">{{ value }}</a>
            </div>
            <button type="button" class="link-pay-print" @click="printQr">
              <i class="fas fa-print ml-2" aria-hidden="true"></i>
              پرینت QR Code
            </button>
          </div>
        </template>
      </net-pa-card>
    </div>
  </div>
</template>
<script>
import Payment from '../CmpNetPa/Payment.vue'
import Loading from '../Tools/NetPa/Loading.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import QrcodeVue from 'qrcode.vue'
import html2pdf from 'html2pdf.js'
import Num2persian from 'num2persian'
import CaptchaBox from '../CmpLogin/CaptchaBox.vue'
export default {
  components: {
    Payment,
    Panel,
    NetPaCard,
    Loading,
    QrcodeVue,
    CaptchaBox,
  },
  computed: {
    pageDescription() {
      const name = this.$session.get('NameSandogh')
      return name ? `واریز و پرداخت از طریق لینک — ${name}` : 'واریز و پرداخت از طریق لینک'
    },
  },
  data() {
    return {
            captchaText:"",
      captchaId:"",
      CaptchaValid:false,
      captchaCode: '',
      userInput: '',
      result: '',
      width: 150,
      height: 50,

      codeMeli: '',
      QrCode: false,
      value: window.location.href,
      size: 300,
      appsettings: {},
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenasNew',
        Token: '',
      },
      Resultcmb: -1,
      ShenaseOzv: null,
      ListModel: null,
      IsLoad: false,
      DepositType: 1,
      Shenase: '',
      LinkId: '',
      VCode: '',
      Mablagh: '',
      NameFamily: '',
      Mobile: '',
      Description: '',
      Result: null,
      GatewayCode: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenaseVarizNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVCNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowGetShenase: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      FixVariz: false,
      loadingRender: false,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      IsQuery: false,
      IsLinkPay: false,
      IsLinkPayCustom: false,
      wwwtblShobeid: null,
      appsettings: {},
    }
  },
  methods: {
    stripNameQuotesForSend(str) {
      return (str == null ? '' : String(str)).replace(/['"]/g, '')
    },
    onNameFamilyInput(e) {
      this.NameFamily = this.stripNameQuotesForSend(e.target.value)
    },
    onCaptchaValid({ valid, captchaId, userInput }) {     
    this.CaptchaValid = valid;
    this.captchaId = captchaId;
    this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    ToPersian(number) {
      return Num2persian(number)
    },
    gettblCustomer() {
      this.loading = true
      var settings = {
        method: 'Post',
        url: this.$GetapiBase()+ 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: 'GetTblCustomer',
          method: 'GET',
          Token: '',
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name
            this.$session.set('NameSandogh', data.name)
            this.$session.set('CustCode', data.custCode)
            document.title = ' خدمات الکترونیکی ' + data.name
            this.loading = false
            this.CheckupLinkPay()
          })
          .catch(function (error) {
            //console.log(error)
          })
      })
    },
    // getDepositType(val) {
    //   this.DepositType = val
    //   this.Result = null
    //   // if(val==3){

    //   // }
    // },

    applyShenaseSuccess(result) {
      this.refreshCaptcha()
      this.$session.set('likpay', window.location.href)
      this.wwwtblShobeid = result.wwwtblShobeid
      this.Result = result
      if (result.tblSarfaslTypeId != 1) {
        this.FixVariz = false
      }
      if (this.$route.query.IsVgate != undefined) {
        this.$session.set('TokenVgate', true)
      }
      const mabEl = document.getElementById('Mab')
      const btnEl = document.getElementById('BtnPayment')
      const alertEl = document.getElementById('AletSumMab')
      if (
        result.mande + result.wwwJarime - result.sumMabTaeedNaShode <= 0 &&
        result.tblSarfaslTypeId == 1
      ) {
        if (mabEl) mabEl.classList.add('d-none')
        if (btnEl) btnEl.classList.add('d-none')
        if (alertEl) alertEl.classList.remove('d-none')
      } else {
        if (mabEl) mabEl.classList.remove('d-none')
      }

      if (result.mablaghGhestVam > 0) {
        this.Mablagh = result.sumGhabelPar
        this.CheckUpMablagh = result.sumGhabelPar
      } else {
      if (result.tblSarfaslTypeId != 1) {
        this.Mablagh=result.mablaghSharj>0 ? result.sumGhabelPar : ''
      }
      else{
        this.Mablagh = ''
      }
      }

      if (this.LinkId != '' && this.LinkId > 0) {
        this.CheckLinkId(this.LinkId)
      }
    },
    CheckupShenase() {
      if (this.Shenase != '') {
        this.loadingRender = true
        this.VCode = ''

        const formData = new FormData()
        formData.append('ShenaseVariz', this.$Encryption(this.Shenase))
        this.$IssuePayTicket({ ShenaseVariz: this.$Encryption(this.Shenase), LinkPayId: this.LinkId, LinkToken: this.$route.query.lt }) // NetPa HANDOFF bilit-e pardakht F1
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.state == 'Success') {
            this.applyShenaseSuccess(data.result)
            this.loadingRender = false
          } else {
            if (this.$route.query.sh) {
              if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
                this.$mySweetDefaultTost('خطا', 'شناسه واریز موجود در لینک صحیح نمیباشد.', 'error', 5000)
                this.$router.push({ name: 'LoginPage' })
              }
            } else this.$mySweetDefaultTost('خطا', 'شناسه وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
            this.refreshCaptcha()
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه واریز خالی می باشد ', 'error', 2500)
        this.refreshCaptcha()
        this.Result = null
      }
    },
    Payment() {
        if(!this.CaptchaValid){
            this.refreshCaptcha()
          this.$mySweetDefaultTost('خطا', ' متن تصویر به درستی وارد نشده است', 'error', 2000)
           return;
        }
      if (this.$ValidForm('div1')) {
        if (this.Result.tblSarfaslTypeId != 1) {
          this.SendPayment()
        } else {
          if (this.Result.sumGhabelPar || this.Result.sumGhabelPar != null) {
            if (Number(this.Mablagh) > this.Result.mande + this.Result.wwwJarime - this.Result.sumMabTaeedNaShode) {
              this.$mySweetDefault('هشدار', 'مبلغ پرداختی نمی تواند بیشتر از مانده تسهیلات باشد . ', 'warning', 2500)
            } else {
              this.FormulaJarime()
            }
          } else {
            this.$mySweetDefault('خطا', 'تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر بیشتر با ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' /شعبه تماس بگیرید', 'error', 2500)
          }
        }
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
      if (val > 0) {
        this.loadingRender = false
      }
    },
    FixVarizGhest(val) {
      
      if (this.Result.tblSarfaslTypeId != 1) {
        this.FixVariz = false
      }else{
        this.FixVariz = val
      }
    },
    FixVarizGhestHasJarime(val) {
      var jarime = this.Result.wwwJarime
      if (jarime > 0) {
        this.FixVariz = val
      }
    },
    SendPayment() {
      const nameForSend = this.stripNameQuotesForSend(this.NameFamily)
      if (this.$route.query.linkId && this.$route.query.linkId > 0) {
        // console.log('expirLink')
        this.expirLink()
      }
      this.Mablagh = this.Mablagh
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.Result.id,
        Mablagh: Number(this.Mablagh),
        SharhRiz: ' واریز | پرداخت  توسط لینک پرداخت ' + this.Description + this.Result.vCode + ' _پرداخت کننده_ ' + nameForSend,
        WwwtblAzaId: this.Result.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.Result.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.Result.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime),
        TarixGhest: this.Result.minTarGhestBedehkar,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh)
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' واریز | پرداخت  توسط لینک پرداخت ' + ' _پرداخت کننده_ ' + nameForSend
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.Result.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh + '',
            nameForSend,
            'linkpay',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.Shenase + '',
            this.Result.vCode,
            'واریز | پرداخت  توسط لینک پرداخت',
            this.Result.wwwtblAzaId + '',
            this.$session.get('CustCode'),
            this.Result.wwwtblShobeid + '',
            result.idRepoMaster,
            this.Result.codeMeli.trim(),
            this.Result.nameFamily,
            this.Result.mobile,
            this.Result.codeMeli.trim()
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
    },
    FormulaJarime() {
      if (Number(this.Mablagh) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        if (this.$session.get('CustCode') == 561) {
          this.MabFormulaJarime = (Number(this.Mablagh) / Number(this.CheckUpMablagh)) * MablaghJarime
        } else {
          this.MabFormulaJarime = (Number(this.Mablagh) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        this.SendPayment()
      } else {
        this.MabFormulaJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        this.SendPayment()
      }
    },
    CheckupLinkPay() {
      if (this.$route.query.sh) {
        if (this.$route.query.sh != null) {
          if (this.IsLinkPay) {
            this.loadingRender = true
            this.IsQuery = true
            this.Shenase = this.$route.query.sh + ''
            if (this.$route.query.linkId && this.$route.query.linkId > 0) {
              this.LinkId = this.$route.query.linkId
            }
            this.CheckupShenase()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' هماهنگ کنید', 'error', 8000)
            this.loadingRender = true
          }
        } else {
          this.IsQuery = false
        }
      } else {
        this.IsQuery = false
      }
    },
    printQr() {
      var htmls = document.getElementById('qrcode')
      var htmlObject = document.createElement('div')

      // text-align: center !important; padding-top: 5cm; padding: bottom 5cm
      htmlObject.style.textAlign = 'center'
      htmlObject.style.paddingTop = '5cm'
      htmlObject.style.background = ' url(./Template/NewMenu/img/NetPaImage/LinkPay.png)'
      htmlObject.style.backgroundSize = '100%'
      htmlObject.style.height = '21cm'
      htmlObject.innerHTML = htmls.innerHTML
      html2pdf(htmlObject, {
        jsPDF: { format: 'a5' },
      })
    },
    applyLinkIdSuccess(data) {
      this.FixVariz = true
      this.IsLinkPayCustom = true
      this.Mablagh = data.amount
      this.NameFamily = data.name
      this.Mobile = data.mobile
      this.Description = data.des
    },
    CheckLinkId() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'Get?' + 'linkPayId=' + this.LinkId + (this.$route.query.lt ? '&lt=' + encodeURIComponent(this.$route.query.lt) : '') } // NetPa HANDOFF bilit-e pardakht F2 : kod-e link
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
          this.applyLinkIdSuccess(res.data)
        } else {
          this.$mySweetDefaultTost('خطا', 'لینک منقضی شده است ', 'error', 3000)
          this.$router.push({ name: 'LoginPage' })
        }
      })
    },
    expirLink() {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'get',
        Action: 'LinkPay',
        Token: this.$session.get('TokenNetPa'),
      }
      DataAxios.ArryfildValue = { Id: 'GetIsUse?' + 'linkPayId=' + this.LinkId + (this.$route.query.lt ? '&lt=' + encodeURIComponent(this.$route.query.lt) : '') } // NetPa HANDOFF bilit-e pardakht F2 : kod-e link
      this.$GetData_Header(DataAxios).then((res) => {
        if (res.status == 'Ok') {
        }
      })
    },
    goToLogin() {
      this.$router.push({ name: 'LoginPage' })
    },
    CheckInternetBankVersion() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSettings.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((result) => {
        console.log(this.$store.state.VersionSoftware);
        console.log(result.data.VersionSoftware);
        
        console.log(typeof(this.$store.state.VersionSoftware));
        console.log(typeof(result.data.VersionSoftware));
        
        
        if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
          // window.location = window.location.href + '?eraseCache=true'
          this.$router.push({ name: 'LoginPage' })
        } else {
          this.appsettings = result.data
          // console.log('😂 ~ this.appsettings:', this.appsettings)
          this.$store.state.VersionSoftware = result.data.VersionSoftware
        }
      })

      this.$store.state.loadingRender = false
      var ver = localStorage.getItem('VersionSoftware')

      if (ver == null) {
        localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
      } else {
        var OldVer = localStorage.getItem('VersionSoftware')
        var NewVer = this.$store.state.VersionSoftware
        console.log('😂 ~ NewVer:', NewVer)
        console.log('😂 ~ OldVer:', OldVer)
        if (OldVer != NewVer) {
          localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
          this.$swal({
            title: 'بروزرسانی',
            text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
            icon: 'success',
            position: 'center',
            confirmButtonText: 'تایید',
            showConfirmButton: true,
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload(true)
            }
          })
        }
      }
    },
  },
  // updated() {
  //   if (document.getElementById("SelectNoeVarizi") === document.activeElement) {
  //     if (this.DepositType == 1) {
  //       document.getElementById("Shenase").focus();
  //     }
  //     if (this.DepositType == 2) {
  //       document.getElementById("VCode").focus();
  //     }
  //   }
  // },
  mounted() {
    document.documentElement.classList.add('link-pay-html')
    document.body.classList.add('link-pay-html')
    if (!this.$route.query.sh) {
      this.$router.push({ name: 'LoginPage' })
    }
    this.CheckInternetBankVersion()
  },
  beforeDestroy() {
    document.documentElement.classList.remove('link-pay-html')
    document.body.classList.remove('link-pay-html')
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      this.appsettings = result.data
      this.IsLinkPay = result.data.IsLinkPay ? result.data.IsLinkPay : false

      this.gettblCustomer()
    })

    //this.gettblCustomer()
  },
}
</script>
<style scoped>
.link-pay-page {
  min-height: 100vh;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  background: #f5f7fb !important;
}

.link-pay-shell {
  width: 100%;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

.link-pay-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.link-pay-qr-toggle {
  flex: 0 0 auto;
  min-height: 32px;
  padding: 4px 10px;
  color: #068997;
  border: 1px solid rgba(5, 184, 200, 0.28);
  border-radius: 10px;
  background: #e9f9fb;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.link-pay-form,
.link-pay-layout,
.link-pay-main {
  width: 100%;
}

.link-pay-layout,
.link-pay-main {
  display: grid;
  gap: 8px;
}

.link-pay-lookup {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
}

.link-pay-input {
  min-height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
}

.link-pay-amount {
  font-size: 18px !important;
  font-weight: 800;
}

.link-pay-check {
  min-width: 72px;
  min-height: 40px;
  padding: 0 12px;
  color: #068997;
  border: 1px solid rgba(5, 184, 200, 0.28);
  border-radius: 10px;
  background: #e9f9fb;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.link-pay-result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 8px 10px;
  color: #29345f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
}

.link-pay-result__due {
  color: #b44f46;
}

.link-pay-amount-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: center;
}

.link-pay-amount-formatted {
  color: #c72816;
  font-size: 14px;
  font-weight: 700;
}

.link-pay-amount-words {
  color: #6b7b8e;
  font-size: 12px;
}

.link-pay-payer {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.link-pay-notes {
  min-height: 64px;
  resize: vertical;
}

.link-pay-captcha {
  width: 100%;
}

.link-pay-captcha ::v-deep .input-group {
  width: 100%;
  margin-bottom: 0 !important;
}

.link-pay-captcha ::v-deep .form-control {
  min-height: 40px;
  height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px 0 0 10px;
  background: #fff;
  box-shadow: none;
}

.link-pay-captcha ::v-deep .form-control:focus {
  border-color: #05b8c8;
  box-shadow: 0 0 0 2px rgba(5, 184, 200, 0.2);
}

.link-pay-captcha ::v-deep .input-group-append {
  margin-left: 0;
}

.link-pay-captcha ::v-deep .input-group-text {
  height: 40px;
  min-height: 40px;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-left: 0;
  border-radius: 0 10px 10px 0;
  background: #fff;
}

.link-pay-captcha ::v-deep .input-group-text img,
.link-pay-captcha ::v-deep img.input-group-text {
  height: 40px;
  width: auto;
}

.link-pay-checkout {
  padding: 10px;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #fff;
}

.link-pay-hint {
  margin: 0;
  color: #6b7b8e;
  font-size: 12px;
  line-height: 1.7;
  text-align: right;
}

.link-pay-submit {
  width: 100%;
  min-height: 42px;
  border-radius: 12px;
  font-weight: 700;
}

.link-pay-qr {
  display: grid;
  justify-items: center;
  gap: 12px;
}

.link-pay-qr-box {
  display: grid;
  justify-items: center;
  width: 100%;
  max-width: 320px;
  padding: 16px;
  border-radius: 14px;
  background: #2a3f54;
}

.link-pay-qr-name {
  margin-bottom: 12px;
  color: #ffc107 !important;
  font-size: 14px;
  font-weight: 700;
}

.link-pay-qr-link {
  display: block;
  margin-top: 10px;
  color: #fff !important;
  font-size: 11px;
  word-break: break-all;
}

.link-pay-print {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 14px;
  color: #068997;
  border: 1px solid rgba(5, 184, 200, 0.28);
  border-radius: 10px;
  background: #e9f9fb;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

@media (min-width: 420px) {
  .link-pay-payer {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  }
}

@media (max-width: 575px) {
  .link-pay-notes {
    min-height: 52px;
  }

  .link-pay-qr-toggle {
    padding: 4px 8px;
    font-size: 11px;
  }
}
</style>
<style>
html.link-pay-html,
body.link-pay-html,
body.link-pay-html #app,
html.link-pay-html body,
#LinkPayPage.link-pay-page,
#LinkPayPage {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}

#LinkPayPage .link-pay-card.netpa-card,
#LinkPayPage .link-pay-card {
  height: auto !important;
  background: #fff !important;
}

#LinkPayPage .netpa-card__header,
#LinkPayPage .netpa-card__body {
  background: #fff !important;
}

#LinkPayPage .link-pay-captcha .input-group {
  width: 100%;
  margin-bottom: 0 !important;
}

#LinkPayPage .link-pay-captcha .form-control {
  min-height: 40px;
  height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px 0 0 10px;
  background: #fff;
  box-shadow: none;
}

#LinkPayPage .link-pay-captcha .form-control:focus {
  border-color: #05b8c8;
  box-shadow: 0 0 0 2px rgba(5, 184, 200, 0.2);
}

#LinkPayPage .link-pay-captcha .input-group-text {
  height: 40px;
  min-height: 40px;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-left: 0;
  border-radius: 0 10px 10px 0;
  background: #fff;
}

@media (max-width: 767px) {
  #LinkPayPage .netpa-card__header {
    min-height: 48px;
    padding: 10px 12px !important;
  }

  #LinkPayPage .netpa-card__body {
    padding: 10px !important;
  }

  #LinkPayPage .netpa-page-panel {
    margin-bottom: 8px;
  }

  #LinkPayPage .alert {
    margin-bottom: 8px;
  }
}
</style>
